import { DENSITIES, type Density } from "../density";

const LABEL: Record<Density, string> = {
  comfortable: "Comfortable",
  compact: "Compact",
  dense: "Dense",
};

/**
 * The density picker (proposal: "comfortable / compact / dense, so on-call can
 * see everything"). The choice is persisted per browser.
 */
export default function DensityControl({
  value,
  onChange,
}: {
  value: Density;
  onChange: (next: Density) => void;
}) {
  return (
    <div className="dropdown dropdown-end">
      <div
        tabIndex={0}
        role="button"
        className="btn btn-ghost btn-sm"
        title={`Density: ${LABEL[value]}`}
      >
        Density
      </div>
      <ul
        tabIndex={0}
        className="dropdown-content menu bg-base-100 rounded-box z-20 mt-2 w-44 p-2 shadow"
      >
        {DENSITIES.map((density) => (
          <li key={density}>
            <button
              type="button"
              className={value === density ? "active" : ""}
              aria-pressed={value === density}
              onClick={() => onChange(density)}
            >
              {LABEL[density]}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
